import { initWidget } from '@/utils/Shell';
import FormWidget from './FormWidget.vue';

initWidget('FormWidget', FormWidget);
